import axios from 'axios';
import Api from './api';

let ApiRag = {}

let baseURLBack = {}

if (Api) {
    let baseUrlResponse = Api.apiurlrag()

    if (baseUrlResponse) {
        baseURLBack = `${baseUrlResponse}api`
    }
    let token = localStorage.getItem('accesstoken')

    ApiRag = axios.create({
        baseURL: baseURLBack,
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`
        },
    })
}

export default ApiRag